"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropList = void 0;
var _react = require("react");
var _DropList = require("./DropList.styles");
var _List = require("../../../../Data/List");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DropList = function DropList(props) {
  var options = props.options,
    additionalOptions = props.additionalOptions,
    selectedOptions = props.selectedOptions,
    isMultiSelect = props.isMultiSelect,
    onSelectOption = props.onSelectOption,
    _props$optionSize = props.optionSize,
    optionSize = _props$optionSize === void 0 ? 'small' : _props$optionSize,
    additionalOptionsBtnLabel = props.additionalOptionsBtnLabel,
    id = props.id;
  var styles = (0, _DropList.useStyles)(props);
  var anyAdditionalOptionSelected = additionalOptions && additionalOptions.length > 0 && selectedOptions.length > 0 ? additionalOptions.filter(function (o) {
    return selectedOptions.includes(o);
  }).length > 0 : false;
  var _useState = (0, _react.useState)(anyAdditionalOptionSelected),
    _useState2 = _slicedToArray(_useState, 2),
    isAdditionalOptionsVisible = _useState2[0],
    setIsAdditionalOptionsVisible = _useState2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Select__dropList'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_List.List, {
      role: "listbox",
      id: id,
      isMultiSelect: isMultiSelect,
      children: [options.map(function (option) {
        var args = option.isSeparator ? {
          isSeparator: true,
          role: 'title',
          isSelected: false,
          isWithCheckbox: false,
          onClick: undefined
        } : {
          role: 'option',
          isSelected: Boolean(selectedOptions.find(function (op) {
            return (op === null || op === void 0 ? void 0 : op.value) === option.value;
          })),
          isWithCheckbox: isMultiSelect,
          onClick: function onClick() {
            onSelectOption(option);
          }
        };
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, _objectSpread(_objectSpread({
          className: option.className,
          id: option.value.toString(),
          color: "basic",
          size: optionSize,
          isDisabled: option.isDisabled
        }, args), {}, {
          children: option.label
        }), option.value.toString());
      }), additionalOptions && additionalOptions.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          id: "extra_options_seperator",
          isSelected: false,
          isWithCheckbox: false,
          onClick: undefined,
          size: optionSize,
          role: "title",
          color: "basic",
          isSeparator: true
        }), !isAdditionalOptionsVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          id: "show_extra_options_button",
          isSelected: false,
          isWithCheckbox: false,
          onClick: function onClick() {
            setIsAdditionalOptionsVisible(true);
          },
          size: optionSize,
          role: "title",
          color: "basic",
          children: additionalOptionsBtnLabel
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: additionalOptions.map(function (additionalOption) {
            var args = additionalOption.isSeparator ? {
              isSeparator: true,
              role: 'title',
              isSelected: false,
              isWithCheckbox: false,
              onClick: undefined
            } : {
              role: 'option',
              isSelected: Boolean(selectedOptions.find(function (op) {
                return (op === null || op === void 0 ? void 0 : op.value) === additionalOption.value;
              })),
              isWithCheckbox: isMultiSelect,
              onClick: function onClick() {
                onSelectOption(additionalOption);
              }
            };
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, _objectSpread(_objectSpread({
              className: additionalOption.className,
              id: additionalOption.value.toString(),
              color: "basic",
              size: optionSize,
              isDisabled: additionalOption.isDisabled
            }, args), {}, {
              children: additionalOption.label
            }), additionalOption.value.toString());
          })
        })]
      })]
    })
  });
};
exports.DropList = DropList;